import { useEffect } from "react";

const useEnterKey = (callback) => {
  useEffect(() => {
    if (!callback) return;
    const handleEnterPress = (event) => {
      if (event.key === "Enter") {
        const activeTag = document.activeElement.tagName.toLowerCase();
        const isClickable =
          activeTag === "button" ||
          activeTag === "a" ||
          document.activeElement.type === "submit";

        if (!isClickable) {
          callback(event);
        }
      }
    };

    window.addEventListener("keydown", handleEnterPress);
    return () => {
      window.removeEventListener("keydown", handleEnterPress);
    };
  }, [callback]);
};

export default useEnterKey;
